<!-- 开启同时在线人数，如果观看人数达到上限，后续登录观看的用户提示该限制观看弹框 -->
<template>
    <el-dialog title="" :visible.sync="dialogVisible" width="295px" :custom-class="'limit-online-user-dialog'" :show-close="false" :close-on-click-modal="false">
        <div class="content">
            <img src="@/assets/imgs/liveDialog/limit_watch_video.png" width="230px"/>
            <p class="tips">直播间人数上限，稍等空位</p>
        </div>
    </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    }
  }
}
</script>

<style>
.el-dialog.limit-online-user-dialog {
    width: 295px;
    height: 290px;
    margin-top: 30vh !important;
}
.el-dialog.limit-online-user-dialog .el-dialog__header {
    display: none;
}
.el-dialog.limit-online-user-dialog .el-dialog__body {
    height: 100%;
    border-radius: 15px;
    box-sizing: border-box;
    background: linear-gradient(rgba(174,202,247,0.80) 0%, rgba(208,228,246,0.20) 20%);
}
.el-dialog.limit-online-user-dialog .el-dialog__body .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
}
.el-dialog.limit-online-user-dialog .el-dialog__body .content .tips{
    color: #202020;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/limitOnlineUserDialog.vue